<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Italian’s Ruthless Marriage Bargain</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><a id="page01"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>“Even if I do sleep with you, it doesn’t mean I’m going to marry you.”</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>“Before you start introducing conditions again,” he suggested huskily, “you should consider that two can play at that game.” Smiling fiercely down into her bewildered face, he elaborated. “I could, for instance, say if you won’t marry me, I won’t make love to you.”</span></p><p class="paraNoIndent1"><span>Every nerve in her body screamed out in protest at the suggestion.</span></p><p class="paraNoIndent1"><span>“You’re not serious!” She scanned his face for any sign that this was an empty threat, and found none. It was a very persuasive argument.</span></p></div></a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// italiansruthlessmarriagebargainthe_fm01.vue?12cb4e18